import React from "react";
import Card from "../components/ui/Card";

export default function Support() {
  return (
    <div className="bg-[#f0f2f7] pb-2 screen-enter">
      {/* Header */}
      <div className="bg-brand-dark px-[17px] pt-[14px] pb-[18px]">
        <h2 className="text-white text-[17px] font-bold mb-0.5">Support DiWAD</h2>
        <p className="text-white/60 text-[11px]">Nous sommes là pour vous aider</p>
      </div>

      <div className="p-3">
        {/* Hero card */}
        <Card className="mb-3 text-center">
          <div className="w-[52px] h-[52px] bg-brand-orange-light rounded-2xl flex items-center justify-center mx-auto mb-2.5 border border-brand-orange-border">
            <i className="fa fa-headset text-brand-orange text-[22px]" />
          </div>
          <p className="text-[13px] font-bold text-brand-dark mb-1">
            Une question ou un problème ?
          </p>
          <p className="text-[11px] text-gray-400 leading-relaxed">
            Notre équipe est disponible<br />
            du lundi au samedi · 07h00 – 21h00
          </p>
          <div className="inline-flex items-center gap-[5px] mt-[9px] bg-brand-success-light border border-brand-success-border rounded-[20px] px-3 py-1">
            <div className="w-[7px] h-[7px] bg-brand-success rounded-full pulse-dot" />
            <span className="text-[10px] font-bold text-brand-success">En ligne actuellement</span>
          </div>
        </Card>

        {/* Canaux */}
        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.7px] mb-2">
          Nous contacter
        </p>

        {/* WhatsApp */}
        <button className="w-full rounded-[18px] p-4 flex items-center gap-3.5 mb-2.5 cursor-pointer border-none tap-highlight active:opacity-80 text-left" style={{ background: "#25D366" }}>
          <div className="w-[42px] h-[42px] bg-white/20 rounded-[13px] flex items-center justify-center flex-shrink-0">
            <i className="fab fa-whatsapp text-white text-[22px]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-white mb-0.5">WhatsApp</p>
            <p className="text-[11px] text-white/85">Réponse rapide · Chat en direct</p>
            <p className="text-xs font-semibold text-white/95 mt-1">+237 6XX XXX XXX</p>
          </div>
          <div className="w-7 h-7 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="fa fa-arrow-right text-white" style={{ fontSize: 10 }} />
          </div>
        </button>

        {/* Appel */}
        <button className="w-full bg-brand-blue rounded-[18px] p-4 flex items-center gap-3.5 mb-3 cursor-pointer border-none tap-highlight active:opacity-80 text-left">
          <div className="w-[42px] h-[42px] bg-white/20 rounded-[13px] flex items-center justify-center flex-shrink-0">
            <i className="fa fa-phone-alt text-white text-lg" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-white mb-0.5">Appel direct</p>
            <p className="text-[11px] text-white/85">Parler à un conseiller</p>
            <p className="text-xs font-semibold text-white/95 mt-1">+237 6XX XXX XXX</p>
          </div>
          <div className="w-7 h-7 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="fa fa-arrow-right text-white" style={{ fontSize: 10 }} />
          </div>
        </button>

        {/* Autre demande */}
        <Card padding={false}>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.7px] px-[13px] pt-3 pb-0">
            Autre demande
          </p>
          <div className="px-[13px] py-[11px] flex items-center gap-2.5 cursor-pointer">
            <div className="w-[30px] h-[30px] bg-brand-danger-light rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="fa fa-exclamation-triangle text-brand-danger" style={{ fontSize: 11 }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-brand-dark">
                Signaler un problème de transaction
              </p>
              <p className="text-[10px] text-gray-400 mt-0.5">
                Transaction incorrecte, montant erroné…
              </p>
            </div>
            <i className="fa fa-chevron-right text-gray-200 flex-shrink-0" style={{ fontSize: 10 }} />
          </div>
        </Card>
      </div>
    </div>
  );
}
